import { mapPxToRem } from "../utils/mapPxToRem";

const radii = {
    base: "4px",
};

export default mapPxToRem(radii);
